import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
export const EquityDropdown = (props) => {
    const [value, setValue] = React.useState(props.defaultVal
        ? props.selectedDefaultVal
            ? props.selectedDefaultVal
            : props === null || props === void 0 ? void 0 : props.itemlist[0]
        : {
            title: props.defaultText ? props.defaultText : "",
            value: "",
        });
    React.useEffect(() => {
        setValue(props.defaultVal
            ? props.selectedDefaultVal
                ? props.selectedDefaultVal
                : props === null || props === void 0 ? void 0 : props.itemlist[0]
            : {
                title: props.defaultText ? props.defaultText : "",
                value: "",
            });
    }, [props.selectedDefaultVal]);
    const change = (val) => {
        const item = JSON.parse(val);
        setValue(item);
        props.selectedValue(item);
    };
    React.useEffect(() => {
        setValue(props.defaultVal && props.selectedDefaultVal
            ? props === null || props === void 0 ? void 0 : props.selectedDefaultVal
            : props === null || props === void 0 ? void 0 : props.itemlist[0]);
    }, [props.selectedDefaultVal]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { className: `equity-dropdown-block ${props.externalClassname && props.externalClassname}`, onSelect: change },
            React.createElement(Dropdown.Toggle, { className: "equitydrop" },
                React.createElement("div", { className: "main-title-forbreak" }, value === null || value === void 0 ? void 0 : value.title),
                React.createElement("i", { className: `edel-icon-arrow-down ${props.bigIcon ? "equity-drp-bigicon" : ""}` })),
            React.createElement(Dropdown.Menu, { id: props.id, align: props.align, className: props.ddmenuClassName },
                props.itemlist.map((val, idx) => {
                    return (React.createElement(Dropdown.Item, { className: props.highlightSelectedItem && value.value == val.value
                            ? "DMSan_14_700"
                            : "", eventKey: JSON.stringify(val), key: idx }, val === null || val === void 0 ? void 0 :
                        val.title,
                        props.listDeleted === true ? (React.createElement(React.Fragment, null,
                            React.createElement("div", null,
                                React.createElement("i", { className: "edel-icon-trash trash" })))) : ("")));
                }),
                props.hideEdbtnlink && (React.createElement(Dropdown.Item, { eventKey: "n", key: "n" }, props.edbtnlink && React.createElement(React.Fragment, null, props.linkdata)))))));
};
